import styled from 'styled-components';
import { ContainerSection } from '@/main/components/shared/styles';

export const Container = styled(ContainerSection)``;

interface ITextValue {
  cursor: 'default' | 'pointer';
  textUnderline?: boolean;
}

export const TextValue = styled.span<ITextValue>`
  display: block;
  text-align: center;
  text-decoration: ${props => (props.textUnderline ? 'underline' : 'default')};
  ${props =>
    props.cursor === 'default' &&
    `
    cursor: default;
    `}
  ${props =>
    props.cursor === 'pointer' &&
    `
    cursor: pointer;
    `}
`;